<template lang="pug">
  tbody
    table-row(
      v-for="row in rows",
      :data="row",
      :key="row.key",
      :columns="columns"
    )
</template>

<script>
import TableRow from './table-row'

export default {
  name: 'table-body',
  props: ['columns', 'rows'],
  components: { TableRow }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// table-body.vue?144486ae